import { FC, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { FormField, IButton, Spinner } from "../../../../ui-kit";
import { loginStore } from "./LoginpageStore";
import { useHandleForm } from "../../../../hooks/useHandleForm";
import { useStatusMessage } from "../../../../hooks/useStatusMessage";
import styles from "./LoginPage.module.scss";
import { useBreadcrumbs } from "../../../../hooks/useBreadcrumbs";

const LoginPage: FC = observer(() => {
  useEffect(() => {
    loginStore.getdataHelp();
  }, []);
  useEffect(() => {
    setValue("supportAddress", loginStore.supportAddress);
    setValue("email", loginStore.email);
  }, [loginStore.supportAddress,loginStore.email]);
  const onSubmit = (data) => {
    loginStore.updatedataHelp(data);
  };
  const { setValue, register, watchAllField, errors, control, handleSubmit } =
    useHandleForm();
  useStatusMessage(loginStore.messageStatus);
  useBreadcrumbs([
    { link: "/admin/system/loginpage", name: "Администрирование" },
    { link: "/admin/system/loginpage", name: "Системные настройки" },
    { name: "Контакты технической поддержки" },
  ]);
  const form = (
    <form
      onSubmit={handleSubmit(onSubmit)}
      id="formlogin"
      className={styles.form__support}
    >
      <FormField
        label="Текст о технической поддержке на странице авторизации"
        name="supportAddress"
        register={register}
        type="text"
        currentValue={watchAllField.supportAddress}
      />
      <FormField
        label="email администратора"
        name="email"
        register={register}
        type="text"
        currentValue={watchAllField.email}
      />
    </form> 
  );

  return (
    <div className={styles.form__container}>
      {loginStore.isloading.value ? <Spinner /> : form}
      <IButton
        form="formlogin"
        type="submit"
        disabled={loginStore.isloading.value}
      >
        Сохранить
      </IButton>
    </div>
  );
});

export default LoginPage;
